<template>

    <v-modal :title="$t('titles.automatic_review_collection')" :loading="starting">
        <template #alert>
            <v-alert-upgrade feature="asks" />
        </template>
        <template #body>
            <v-alert :message="error" />
            <v-alert type="info">
                <p><span>{{ $t('alerts.activate_intro') }}</span><span v-if="!project.is_active"> {{ $t('alerts.activate_instruction', { count: countFormatted }) }}</span></p>
            </v-alert>
            <v-modal-section :title="$t('labels.strategy')">
                <template #body>
                    <div class="explanation" v-for="(group, key) in project.strategy.explanation" :key="key">
                        <ul>
                            <li class="label no-bullet" :class="icons[key]">
                                <router-link :to="{ name: 'settings.strategy', hash: `#${key}` }"><i :class="icons[key]" class="mr-5" />{{ $t(`labels.${key}`) }}</router-link>
                            </li>
                            <li v-for="(item, index) in group" :key="index" v-html="item" />
                        </ul>
                    </div>
                </template>
                 <template #footer>
                    <v-button v-if="!project.is_active" theme="success" btn-block :loading="loading" @click.native="activateProject">{{ $t('labels.enable_automatic_review_collection') }}</v-button>
                    <v-button v-else theme="danger" btn-block :loading="loading" @click.native="deactivateProject">{{ $t('labels.disable_automatic_review_collection') }}</v-button>
                </template>
            </v-modal-section>
         </template>
        <template #footer>
            <v-button size="sm" theme="white" @click.native="cancel">{{ $t('labels.cancel') }}</v-button>
            <v-button size="sm" theme="white" @click.native="push('settings.strategy')" arrow>{{ $t('labels.edit_strategy') }}</v-button>
        </template>
    </v-modal>

</template>

<style scoped lang="scss">

    .explanation {
        text-align: left;
        .label {
            @include font-semibold(13px);
            color: $color-muted;
            display: inline;
            a {
                color: $color-muted;
                text-decoration: none;
                &:hover {
                    color: $color-text;
                }
            }
        }
        ul {
            list-style-position: outside;
            margin-bottom: 10px;
        }
    }

</style>

<script>

import Modal from '@cmp/Modal';
import ModalSection from '@cmp/ModalSection';
import ConfettiUtil from '@utils/ConfettiUtil';
import numeral from 'numeral';
import ProjectApi from '@api/ProjectApi';

export default {

    components: {
        'v-modal': Modal,
        'v-modal-section': ModalSection,
    },

    data() {
        return {
            starting: true,
            loading: false,
            error: null,
            count: 0,
            icons: {
                settings: 'fas fa-cog',
                reminders: 'fas fa-alarm-clock',
                retries: 'fas fa-rotate-right',
                schedule: 'fas fa-calendar-alt',
                conditions: 'fas fa-sliders',
                limits: 'fas fa-gauge',
            },
        }
    },

    mounted() {
        this.getCustomersUnprocessed();
    },

    computed: {

        countFormatted() {
            let noun = this.count === 1 ? this.$t('labels.customer').toLowerCase() : this.$t('labels.customers').toLowerCase();
            return numeral(this.count).format('0,0') + ' ' + noun;
        },

    },

    methods: {

        getCustomersUnprocessed() {
            ProjectApi.getCustomersUnprocessed(this.project.id)
                .then((response) => {
                    this.starting = false;
                    this.count = response.data.data;
                })
                .catch(() => {
                    this.starting = false;
                });
        },

        activateProject() {
            this.loading = true;
            ProjectApi.activateProject(this.project.id)
                .then((response) => {
                    this.loading = false;
                    this.$store.commit('setAlertSuccess', this.$t('messages.saved'));
                    this.$store.commit('setModal', null);
                    ConfettiUtil.fire();
                })
                .catch((error) => {
                    this.loading = false;
                    this.error = error.response.data.message;
                });
        },

        deactivateProject() {
            this.loading = true;
            ProjectApi.deactivateProject(this.project.id)
                .then((response) => {
                    this.loading = false;
                    this.$store.commit('setAlertSuccess', this.$t('messages.saved'));
                    this.$store.commit('setModal', null);
                })
                .catch((error) => {
                    this.loading = false;
                    this.error = error.response.data.message;
                });
        },

        push(name) {
            this.$router.push({ name: name }).catch(() => {});
            this.cancel();
        },

        cancel() {
            this.$store.commit('setModal', null);
        },

    },

}

</script>
